import React from 'react'

import { useAPIGetProfileCertificatesById } from 'api/profile/useAPIProfile'

import type { TCertificate, TCertificateMeta } from 'types/sertifikat'

const DEFAULT_PAGE_SIZE = 10

export const useCertificates = (userId: string) => {
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
    refetch,
  } = useAPIGetProfileCertificatesById(userId, {
    offset: 0,
    limit: DEFAULT_PAGE_SIZE,
  })

  const certificateResultsData = React.useMemo(() => {
    if (isLoading) return []
    return data?.pages.flatMap((page) => page.data) ?? []
  }, [data?.pages, isLoading])

  const certificateResultsMeta = React.useMemo(() => {
    if (isLoading) return {}
    return data?.pages?.[(data?.pages ?? []).length - 1]?.meta ?? {}
  }, [data?.pages, isLoading])

  return {
    data: certificateResultsData as TCertificate[],
    meta: certificateResultsMeta as TCertificateMeta,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
    refetch,
  }
}
